import React, { Component } from "react";
import Modal, { Styles } from "react-modal";
import "./UploadImagesModel.css";

const getModalStyles = (): Styles => {
  const isSmallScreen = window.innerWidth <= 768;

  return {
    content: {
      height: "auto",
      maxHeight: "80%",
      margin: "auto",
      marginTop: isSmallScreen ? "120px" : "120px",
      position: "relative",
      background: "white",
      borderRadius: "8px",
      padding: "20px",
      overflowY: "auto",
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(0, 0, 0, 0.5)",
    },
  };
};

interface IUploadImagesModelProps {
  isOpen: boolean;
  closeCallback: () => void;
  children?: React.ReactNode;
}

export default class UploadImagesModel extends Component<IUploadImagesModelProps> {
  componentDidUpdate(prevProps: IUploadImagesModelProps) {
    const { isOpen } = this.props;

    if (isOpen !== prevProps.isOpen) {
      document.body.style.overflow = isOpen ? "hidden" : "";
    }
  }

  componentWillUnmount() {
    // Ensure scrolling is re-enabled if the component is unmounted
    document.body.style.overflow = "";
  }

  render() {
    const { isOpen, closeCallback, children } = this.props;

    return (
      <Modal
        className={"widthResponsive"}
        isOpen={isOpen}
        onRequestClose={closeCallback}
        style={getModalStyles()}
      >
        {children}
      </Modal>
    );
  }
}
